import * as React from "react";

function SvgCruncher(props, ref) {
  return (
    <svg
      id="Cruncher_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="40 0 900 900"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Cruncher_svg__st1{fill:#f90}"}</style>
      <path
        d="M915.24 361.74C873.52 199.67 745.93 72.08 583.86 30.36a458.708 458.708 0 00-57.65-10.95v399.98h399.98a460.167 460.167 0 00-10.95-57.65zm-331.38 0V90.2c130.16 38.74 232.8 141.38 271.54 271.54H583.86z"
        fill="#1cb6b7"
      />
      <path
        className="Cruncher_svg__st1"
        d="M871.09 448.21H497.38V74.5c-9.52-.67-19.14-1.02-28.83-1.02s-19.3.34-28.83 1.02C269.67 86.5 128.7 203.88 81.71 361.74a400.233 400.233 0 00-12.62 57.65c-1.36 9.5-2.39 19.12-3.07 28.83-.67 9.52-1.02 19.14-1.02 28.83 0 9.69.34 19.3 1.02 28.83 14.1 199.9 173.81 359.61 373.71 373.71 9.52.67 19.14 1.02 28.83 1.02s19.3-.34 28.83-1.02c9.7-.68 19.32-1.71 28.83-3.07 19.71-2.81 38.96-7.06 57.65-12.62 157.85-47 275.23-187.97 287.22-358.03.67-9.52 1.02-19.14 1.02-28.83 0-9.69-.34-19.31-1.02-28.83zM583.86 803.25a341.042 341.042 0 01-57.65 14.9c-9.48 1.59-19.1 2.8-28.83 3.6-9.5.79-19.12 1.19-28.83 1.19s-19.32-.4-28.83-1.19C271.69 807.9 137.7 673.91 123.84 505.87c-.79-9.5-1.19-19.12-1.19-28.83 0-9.7.4-19.32 1.19-28.83.79-9.73 2-19.35 3.6-28.83 3.32-19.84 8.34-39.11 14.9-57.65 44.42-125.69 159.42-218.04 297.39-229.41v373.54h373.54C801.9 643.83 709.54 758.84 583.86 803.25z"
      />
      <circle className="Cruncher_svg__st1" cx={335.95} cy={289.72} r={40.15} />
    </svg>
  );
}

export default React.forwardRef(SvgCruncher);
